import React, { useState, useEffect } from 'react';

function Contact() {
  useEffect(() => {
    document.title = "Hotel Atlanta | Contact";
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Save submission to localStorage
    const submissions = JSON.parse(localStorage.getItem('submissions')) || [];
    submissions.push(formData);
    localStorage.setItem('submissions', JSON.stringify(submissions));

    alert("Form submitted!");

    setFormData({
      name: '',
      email: '',
      message: ''
    });
  };

  return (
    <>
      <section id="contact-form" className="py-3">
        <div className="container">
          <h1 className="l-heading">
            <span className="text-primary">Contact</span> Us
          </h1>
          <p>Please fill out the form below to contact us.</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                required
                value={formData.name}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                required
                value={formData.email}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                required
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button type="submit" className="btn">Submit</button>
          </form>

          
        </div>
      </section>

      <section id="contact-info" className="bg-dark">
        <div className="container" style={{ display: 'flex', flexWrap: 'wrap' }}>
          <div className="box">
            <i className="fa-solid fa-hotel fa-3x"></i>
            <h3>Location</h3>
            <p>Sector 33, Near DLF Phase 2, Gurugram, Haryana</p>
          </div>
          <div className="box">
            <i className="fa-solid fa-phone fa-3x"></i>
            <h3>Phone Number</h3>
            <p>99999-11111</p>
          </div>
          <div className="box">
            <i className="fa-solid fa-envelope fa-3x"></i>
            <h3>Email Address</h3>
            <p>contactus@hotelatlanta.co</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;